import React from "react";
import { FormControl, makeStyles } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import { DateRange } from "@material-ui/icons";

const useStyles = makeStyles({
	customDatePicker: {
		"& .MuiOutlinedInput-adornedEnd": {
			paddingRight: "6px",
		},
	},
});

const DatePickerComponent = ({
	id,
	label,
	value,
	onChange,
	onBlur,
	error = false,
	helperText = "",
	minDate,
	maxDate,
	required = false,
	disabled = false,
	format = "dd/MM/yyyy",
	dateFilter = undefined,
	inputVariantProps = { variant: "outlined" },
	...props
}) => {
	const classes = useStyles();

	const getDateValue = () => {
		// If value is undefined or empty string, return null
		if (!value) return null;

		// If it's already a Date object
		if (value instanceof Date) return value;

		if (typeof value === "string") {
			try {
				const [year, month, day] = value.split("-").map(Number);
				if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
					return new Date(year, month - 1, day);
				}
			} catch (e) { }
		}

		return null;
	};

	const handleDateChange = (date) => {
		if (!date) {
			onChange("");
			return;
		}

		try {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");

			if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
				onChange(`${year}-${month}-${day}`);
			} else {
				onChange("");
			}
		} catch (e) {
			onChange("");
		}
	};

	return (
		<FormControl error={error} {...props}>
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDatePicker
					variant="inline"
					format={format}
					id={id}
					label={label}
					value={getDateValue()}
					onChange={handleDateChange}
					KeyboardButtonProps={{
						"aria-label": "change date",
						style: { padding: "8px" },
					}}
					keyboardIcon={<DateRange style={{ fontSize: "18px" }} />}
					required={required}
					disabled={disabled}
					onBlur={onBlur}
					error={error}
					helperText={helperText}
					minDate={minDate}
					maxDate={maxDate}
					inputVariant={inputVariantProps.variant}
					className={classes.customDatePicker}
					autoOk={true}
					shouldDisableDate={dateFilter}
				/>
			</MuiPickersUtilsProvider>
		</FormControl>
	);
};

export default DatePickerComponent;
